import { Component, EventEmitter, Output } from '@angular/core';
import {
  GcModalComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { OverlayComponent } from '../../../../overlay/overlay.component';

@Component({
  selector: 'app-error-prevention-modal',
  imports: [
    GcModalComponent,
    OverlayComponent,
    IpoTranslatePipe,
    GcTextComponent,
  ],
  templateUrl: './error-prevention-modal.component.html',
  styleUrl: './error-prevention-modal.component.scss',
})
export class ErrorPreventionModalComponent {
  @Output() proceed = new EventEmitter();
  @Output() cancel = new EventEmitter();
  errorPreventionModal = 'errorPreventionModal';
}
